import React from "react";

import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { IntegratorDetailsDashboardBreadcrumb } from "./IntegratorDetailsDashboardBreadcrumb";

export const IntegratorDetailsDashboardHeader: React.FunctionComponent = () => {
    return (
        <PageHeader>
            <IntegratorDetailsDashboardBreadcrumb />
        </PageHeader>
    );
};
